import { action, decorate, observable } from "mobx";
import { RootStore } from "./RootStore";

export default class ModalStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
    }
    modal = {
        open: false,
        body: null,
        size: "mini" as ("mini" | "tiny" | "small" | "large" | "fullscreen" | undefined)
    }
    loadingModal = false;


    openModal = (content: any, size: "mini" | "tiny" | "small" | "large" | "fullscreen" | undefined = "mini") => {
        this.modal.open = true;
        this.modal.size = size;
        this.modal.body = content;
    }
    closeModal = () => {
        this.modal.open = false;
        this.modal.body = null;
    }
}

decorate(ModalStore, {
    modal: observable.shallow,
    loadingModal: observable,

    closeModal: action,
    openModal: action
});